module.exports = __webpack_public_path__ + "img/17-17.ed10d14c.jpg";